const WORK_POLICY_COLLECTION = "/api/work-policies";

export const workPolicyRoutes = {
  collection: WORK_POLICY_COLLECTION,
  detail: (workPolicyId: number) => `${WORK_POLICY_COLLECTION}/${workPolicyId}`,
  retry: (workPolicyId: number) =>
    `${WORK_POLICY_COLLECTION}/${workPolicyId}/retry`,
  departments: "/api/work-policy-targets/departments",
  employees: "/api/work-policy-targets/employees"
} as const;

export default workPolicyRoutes;
